<template>
  <div>
    <!-- <h1>Property Details</h1> -->
    <div class="creekRoadConservationAreaMAP_Mobile">
      <img src="@/assets/images/CreekRoadConsMapMobile_1.png" class="img-fluid" alt="Wetlands">
    </div>
    <!-- <div class="creekRoadConservationAreaMAP_Mobile">
      <img src="@/assets/images/CreekRoadConservationAreaMAP_Mobile_1.png" class="img-fluid" alt="Wetlands">
    </div> -->
    <div class="creekRoadConservationAreaMAP">
      <img src="@/assets/images/CreekRoadConsMap_1.png" class="img-fluid" alt="Wetlands">
    </div>
    <!-- <div class="creekRoadConservationAreaMAP">
      <img src="@/assets/images/CreekRoadConservationAreaMAP_3.png" class="img-fluid" alt="Wetlands">
    </div> -->

    <!-- <img src="../assets/images/CreekRoadConservationAreaMAP_Mobile_1.png" class="img-fluid" alt="Wetlands"> -->
    <!-- <img src="../assets/images/CreekRoadConservationAreaMAP_2.png" class="img-fluid" alt="Wetlands"> -->
    <!-- <img src="../assets/images/CreekRoadConservationAreaMAP.png" class="img-fluid" alt="Wetlands"> -->

    <div>
      <p>The properties shown in the map above (<i>source: <a
            href="https://www.mapsonline.net/provincetownma/index.html?ts_cama_id=6-1-12-0#x=-7815057.309494,5167311.709675,-7813910.75407,5167871.252609"
            target="_blank">Provincetown Mapsonline</a></i>) are those located in the vicinity of the
        wetlands and are designated as one or more of the following:</p>
      <ul>
        <li>Conservation Restriction (CR) established on the property</li>
        <li>MESA designated</li>
        <li>DEP Wetlands</li>
        <li>DFW/NHESP restricted land</li>
        <li>Open Space</li>
        <li>Unbuildable Town-owned land</li>
        <li>Vacant land (unbuildable)</li>
      </ul>
    </div>

    <!-- <li>Land with NHESP protective stipulations related to Eastern Spadefoot Toad habitat</li> -->

    <table class="table table-striped table-bordered table-hover table-sm">
      <thead class="thead-light">
        <tr>
          <th scope="col" width="5%">Street No.</th>
          <th scope="col" width="20%">Street Name</th>
          <th scope="col" width="70%">Background</th>
          <th scope="col" width="5%">MAP</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td></td>
          <td>Creek Road</td>
          <td>Abutting 30, 25, 23 and 21 Creek Road is an unworked Town road (undeveloped)</td>
          <td><a href="https://www.mapsonline.net/provincetownma/index.html?ts_cama_id=6-3-4-0" target="_blank">MAP</a>
          </td>
        </tr>
        <tr>
          <td>19</td>
          <td>Creek Road</td>
          <td><a
              href="https://search.barnstabledeeds.org/ALIS/WW400R.HTM?WSIQTP=LC01I&W9RCCY=2011&W9RCMM=04&W9RCDD=27&W9CTLN=00998&WSKYCD=D&W9IMID=B11117AA.AXI"
              target="_blank">Declaration of Protective Covenants</a> (2011), NHESP Tracking # 07-23636</td>
          <td><a href="https://www.mapsonline.net/provincetownma/index.html?ts_cama_id=6-1-13-D-19A"
              target="_blank">MAP</a>
          </td>
        </tr>
        <tr>
          <td>21</td>
          <td>Creek Road</td>
          <td><a
              href="https://search.barnstabledeeds.org/ALIS/WW400R.HTM?WSIQTP=LC12I&W9RCCY=2010&W9RCMM=09&W9RCDD=03&W9CTLN=00854&WSKYCD=D&W9IMID=B10246AA.AR3"
              target="_blank">CR established in 2010</a> as upland habitat for the Eastern Spadefoot
            Toad, MESA designated owned by the Town of Provincetown.
            <a href="https://search.barnstabledeeds.org/ALIS/WW400R.HTM?WSIQTP=LC01I&W9RCCY=2011&W9RCMM=04&W9RCDD=27&W9CTLN=00998&WSKYCD=D&W9IMID=B11117AA.AXI"
              target="_blank">Declaration of Protective Covenants</a> (2011), NHESP Tracking # 07-23636</td>
          <td><a href="https://www.mapsonline.net/provincetownma/index.html?ts_cama_id=6-1-13-E" target="_blank">MAP</a>
          </td>
        </tr>

        <tr>
          <td>23</td>
          <td>Creek Road</td>
          <td><a href="http://documents.provincetownma.s3.amazonaws.com/pk_cards_2020/9596.pdf"
              target="_blank">Assessor’s Note</a>: MESA lot, unbuildable, owned by the Town of Provincetown Conservation
            Commission.
            Designated as <a
              href="https://mass-eoeea.maps.arcgis.com/apps/webappviewer/index.html?id=3a7c475cb6d54578ba8c7149d885ad30"
              target="_blank">Creek Road Conservation Area</a> by <a
              href="https://www.mass.gov/orgs/division-of-fisheries-and-wildlife" target="_blank">MassWildlife</a>.
          </td>
          <td><a href="https://www.mapsonline.net/provincetownma/index.html?ts_cama_id=6-3-50-B" target="_blank">MAP</a>
          </td>
        </tr>
        <tr>
          <td>25</td>
          <td>Creek Road</td>
          <td><a href="http://documents.provincetownma.s3.amazonaws.com/pk_cards_2020/9596.pdf"
              target="_blank">Assessor’s Note</a>: MESA lot, unbuildable, owned by the Town of Provincetown Conservation
            Commission.
            Designated as <a
              href="https://mass-eoeea.maps.arcgis.com/apps/webappviewer/index.html?id=3a7c475cb6d54578ba8c7149d885ad30"
              target="_blank">Creek Road Conservation Area</a> by <a
              href="https://www.mass.gov/orgs/division-of-fisheries-and-wildlife" target="_blank">MassWildlife</a>.
          </td>
          <td><a href="https://www.mapsonline.net/provincetownma/index.html?ts_cama_id=6-3-50-F" target="_blank">MAP</a>
          </td>
        </tr>
        <tr>
          <td>28-R</td>
          <td>Creek Road</td>
          <td>Undeveloped land with no known owner</td>
          <td><a href="https://www.mapsonline.net/provincetownma/index.html?ts_cama_id=6-3-4-A" target="_blank">MAP</a>
          </td>
        </tr>
        <tr>
          <td>30</td>
          <td>Creek Road</td>
          <td>Vacant land, owned by the Town of Provincetown. Wetland indicated (Provincetown MapsOnline)</td>
          <td><a href="https://www.mapsonline.net/provincetownma/index.html?ts_cama_id=6-3-4-0" target="_blank">MAP</a>
          </td>
        </tr>
        <tr>
          <td>51</td>
          <td>West Vine Street</td>
          <td><a
              href="https://search.barnstabledeeds.org/ALIS/WW400R.HTM?WSIQTP=LC01I&W9RCCY=2011&W9RCMM=04&W9RCDD=27&W9CTLN=00998&WSKYCD=D&W9IMID=B11117AA.AXI"
              target="_blank">Declaration of Protective Covenants</a> (2011), NHESP Tracking # 07-23636</td>
          <td><a href="https://www.mapsonline.net/provincetownma/index.html?ts_cama_id=6-1-13-A-00A"
              target="_blank">MAP</a>
          </td>
        </tr>
        <tr>
          <td>53</td>
          <td>West Vine Street</td>
          <td><a
              href="https://search.barnstabledeeds.org/ALIS/WW400R.HTM?WSIQTP=LC01I&W9RCCY=2011&W9RCMM=04&W9RCDD=27&W9CTLN=00998&WSKYCD=D&W9IMID=B11117AA.AXI"
              target="_blank">Declaration of Protective Covenants</a> (2011), NHESP Tracking # 07-23636</td>
          <td><a href="https://www.mapsonline.net/provincetownma/index.html?ts_cama_id=6-1-13-B-10A"
              target="_blank">MAP</a>
          </td>
        </tr>
        <tr>
          <td>55</td>
          <td>West Vine Street</td>
          <td><a
              href="https://search.barnstabledeeds.org/ALIS/WW400R.HTM?WSIQTP=LC01I&W9RCCY=2011&W9RCMM=04&W9RCDD=27&W9CTLN=00998&WSKYCD=D&W9IMID=B11117AA.AXI"
              target="_blank">Declaration of Protective Covenants</a> (2011), NHESP Tracking # 07-23636</td>
          <td><a href="https://www.mapsonline.net/provincetownma/index.html?ts_cama_id=6-1-13-00A"
              target="_blank">MAP</a>
          </td>
        </tr>
        <tr>
          <td>57</td>
          <td>West Vine Street</td>
          <td><a
              href="https://search.barnstabledeeds.org/ALIS/WW400R.HTM?WSIQTP=LC01I&W9RCCY=2011&W9RCMM=04&W9RCDD=27&W9CTLN=00998&WSKYCD=D&W9IMID=B11117AA.AXI"
              target="_blank">Declaration of Protective Covenants</a> (2011), NHESP Tracking # 07-23636</td>
          <td><a href="https://www.mapsonline.net/provincetownma/index.html?ts_cama_id=6-1-13-C-00A"
              target="_blank">MAP</a>
          </td>
        </tr>
        <tr>
          <td>66</td>
          <td>West Vine Street</td>
          <td><a href="http://documents.provincetownma.s3.amazonaws.com/pk_cards_2020/322.pdf"
              target="_blank">Assessor’s Note</a>:  INFL1 =(-.45 WETLANDS)</td>
          <td><a href="https://www.mapsonline.net/provincetownma/index.html?ts_cama_id=6-1-11-0" target="_blank">MAP</a>
          </td>
        </tr>
        <tr>
          <td>65-R</td>
          <td>Bayberry Avenue</td>
          <td><a
              href="https://search.barnstabledeeds.org/ALIS/WW400R.HTM?WSIQTP=LR01I&W9RCCY=2019&W9RCMM=03&W9RCDD=15&W9CTLN=00541&WSKYCD=B&W9IMID=B19074AA.AMQ"
              target="_blank">CR established in 2019</a> to protect the Eastern Spadefoot Toad via
            Declaration of
            Restriction,
            NHESP Tracking # 04-14086</td>
          <td><a href="https://www.mapsonline.net/provincetownma/index.html?ts_cama_id=6-3-1-0" target="_blank">MAP</a>
          </td>
        </tr>
        <tr>
          <td>67-R</td>
          <td>Bayberry Avenue</td>
          <td>Conservation land (8.5 acres) owned by th <a
              href="http://documents.provincetownma.s3.amazonaws.com/pk_cards_2020/516.pdf" target="_blank">Provincetown
              Conservation Trust</a> <a href="http://www.provincetownconservationtrust.org/" target="_blank">(Home
              Page).</a>
            Designated as <a
              href="https://mass-eoeea.maps.arcgis.com/apps/webappviewer/index.html?id=3a7c475cb6d54578ba8c7149d885ad30"
              target="_blank">Bayberry Avenue Conservation Area</a> by <a
              href="https://www.mass.gov/orgs/division-of-fisheries-and-wildlife" target="_blank">MassWildlife</a>.
          </td>
          <td><a href="https://www.mapsonline.net/provincetownma/index.html?ts_cama_id=6-3-2-0" target="_blank">MAP</a>
          </td>
        </tr>
        <tr>
          <td>72</td>
          <td>West Vine Street</td>
          <td><a
              href="https://search.barnstabledeeds.org/ALIS/WW400R.HTM?WSIQTP=LR01I&W9RCCY=2008&W9RCMM=03&W9RCDD=18&W9CTLN=01453&WSKYCD=B&W9IMID=B08079AA.ABM"
              target="_blank">CR established in 2008</a> to protect the Eastern Spadefoot Toad via
            Habitat & Open Space
            Covenant. <a href="http://documents.provincetownma.s3.amazonaws.com/pk_cards_2020/323.pdf"
              target="_blank">Assessor’s Note</a>: INFL1 ADJ IS FOR WET .103 AC UNDER PERPETUAL CONSERVATION REST</td>
          <td><a href="https://www.mapsonline.net/provincetownma/index.html?ts_cama_id=6-1-12-0" target="_blank">MAP</a>
          </td>
        </tr>
        <tr>
          <td>78</td>
          <td>West Vine Street</td>
          <td><a
              href="https://search.barnstabledeeds.org/ALIS/WW400R.HTM?WSIQTP=LC12I&W9RCCY=2009&W9RCMM=02&W9RCDD=13&W9CTLN=00731&WSKYCD=D&W9IMID=B09044AA.AJY"
              target="_blank">CR established in 2009</a> to protect the Eastern Spadefoot Toad, groundwater supply and
            pollution prevention.</td>
          <td><a href="https://www.mapsonline.net/provincetownma/index.html?ts_cama_id=6-3-4-B" target="_blank">MAP</a>
          </td>
        </tr>
      </tbody>
    </table>

  </div>
</template>

<script>

  export default {
    name: 'PropertyDetails',
    components: {
    }
  }
</script>

<style>
  .creekRoadConservationAreaMAP_Mobile {
    display: none;
  }

  @media only screen and (max-width: 768px) {

    .creekRoadConservationAreaMAP {
      display: none;
    }

    .creekRoadConservationAreaMAP_Mobile {
      display: block;
    }

  }
</style>